function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import PropTypes from 'prop-types';
import React, { useContext, useMemo, useRef } from 'react';
import { Button as BootstrapButton, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import _ from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import { clearBoundaries, showModal } from '../../redux/actions';
import text, { formatCurrency } from '../../text';
import { isUserUnderTrial, userHasValidMembership } from '../../utilities/user';
import Icon from '../icon/Icon';
import AddOnIcon from '../icon/common/AddOnIcon';
import { getAddOnConfig } from '../mapView/drawingManager/utilities';
import { MapViewContext } from '../mapView/mapViewContext';
import { DELETE_SHAPES_MODAL } from '../modal/DeleteShapesModal';
import ProductModal from '../modal/ProductModal/ProductModal';
export var IconWrapper = function(_param) {
    var icon = _param.icon, isActive = _param.isActive, isDisabled = _param.isDisabled, isSecondary = _param.isSecondary, restProps = _object_without_properties(_param, [
        "icon",
        "isActive",
        "isDisabled",
        "isSecondary"
    ]);
    var isAddOn = !!getAddOnConfig(icon);
    if (!isAddOn) {
        return /*#__PURE__*/ React.createElement(Icon, _object_spread({
            icon: icon,
            isActive: isActive,
            isDisabled: isDisabled,
            isSecondary: isSecondary
        }, restProps));
    }
    var iconName = "".concat(icon).concat(isActive ? '_white' : '');
    if (isDisabled || isSecondary) {
        iconName = "".concat(icon, "_disabled");
    }
    return /*#__PURE__*/ React.createElement(AddOnIcon, _object_spread({
        icon: iconName
    }, restProps));
};
IconWrapper.propTypes = {
    icon: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isSecondary: PropTypes.bool
};
IconWrapper.defaultProps = {
    isActive: false,
    isDisabled: false,
    isSecondary: false
};
var Product = function(param) {
    var data = param.data, product = param.product, charges = param.charges, isReadOnly = param.isReadOnly, index = param.index;
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var dispatch = useDispatch();
    var dataRepresentative = data[1][0] || [];
    var currentUser = useSelector(function(state) {
        return state.profileReducer.userProfile;
    });
    var cardRef = useRef(null);
    var _state_productSelected = state.productSelected, productSelected = _state_productSelected.product;
    var isProductModalOpened = state.showProductModal && productSelected === product;
    var isEssentialUser = useMemo(function() {
        return userHasValidMembership(currentUser) || isUserUnderTrial(currentUser);
    }, [
        currentUser
    ]);
    var price = useMemo(function() {
        if (!charges || !charges.price) {
            return text('notAvailable');
        }
        if (!charges.price.total) {
            return text('toBeConfirmed');
        }
        var price = isEssentialUser ? charges.price.member_total : charges.price.total;
        return formatCurrency(price, charges.currency.name, charges.currency.scale_factor, {}, true);
    }, [
        charges.price,
        charges.currency
    ]);
    var handleDelete = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var selectionsToDelete, childrenSelections;
            return _ts_generator(this, function(_state) {
                selectionsToDelete = state.selections.filter(function(selection) {
                    return selection.product_id === dataRepresentative.product_id;
                });
                childrenSelections = state.selections.filter(function(selection) {
                    return selectionsToDelete.some(function(selectionToDelete) {
                        return selectionToDelete.id === selection.parent_selection_id;
                    });
                });
                if (state.selections.length === selectionsToDelete.length) {
                    dispatch(clearBoundaries());
                }
                dispatch(showModal(DELETE_SHAPES_MODAL, {
                    selectionsToDelete: _to_consumable_array(selectionsToDelete).concat(_to_consumable_array(childrenSelections)),
                    associatedAddOns: childrenSelections
                }));
                event.stopPropagation();
                return [
                    2
                ];
            });
        });
        return function handleDelete(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var isAllSelectionsVisible = state.selections ? _.every([
        'visible',
        true
    ], _.filter([
        'category_name',
        product
    ])(state.selections)) : false;
    var isAllSelectionsHidden = state.selections ? _.every([
        'visible',
        false
    ], _.filter([
        'category_name',
        product
    ])(state.selections)) : false;
    var isSomeSelectionsHidden = state.selections ? _.some([
        'visible',
        false
    ], _.filter([
        'category_name',
        product
    ])(state.selections)) : false;
    var eyeIcon = useMemo(function() {
        return isAllSelectionsVisible ? 'eye' : isAllSelectionsHidden ? 'eye-slash' : 'eye-mixed-state';
    }, [
        isAllSelectionsVisible,
        isAllSelectionsHidden
    ]);
    var handleSetProduct = function() {
        actions.setShowProductModal(true);
        actions.setProductSelected(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), {
                data: data,
                product: product,
                isReadOnly: isReadOnly
            });
        });
        if (state.activeSelection && state.activeSelection.category_name !== product) {
            actions.setGeometries({});
            actions.setGeometriesToLoad({});
            actions.makeSelectionActive(null);
        }
    };
    var activeClass = useMemo(function() {
        return productSelected === product ? "active-".concat(product) : "";
    }, [
        state.productSelected
    ]);
    var getProductSubtitle = function() {
        var isAddOn = !!getAddOnConfig(product);
        if (isAddOn) {
            return product.match(/\b(bim_\w+)/) ? 'Building Information Model' : '2D Feature Plan';
        }
        return text('pointCloud3D');
    };
    return /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", {
        className: "p-0 pb-2"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: classNames(_define_property({}, activeClass, !!activeClass)),
        onClick: handleSetProduct,
        ref: cardRef
    }, ' ', /*#__PURE__*/ React.createElement(Card.Body, {
        className: "product-row-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-row d-flex flex-row align-items-center flex-fill"
    }, /*#__PURE__*/ React.createElement(BootstrapButton, {
        className: "row-action icon-button",
        variant: "light",
        onClick: function(ev) {
            actions.toggleProductVisibility(isAllSelectionsVisible, dataRepresentative);
            ev.stopPropagation();
        },
        type: "button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: classNames({
            original: isSomeSelectionsHidden
        }),
        icon: eyeIcon
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-100 overflow-hidden"
    }, /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: [
            'hover',
            'focus'
        ],
        placement: "top",
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: "other-charge-tooltip",
            className: "wider-x-padding"
        }, /*#__PURE__*/ React.createElement("p", {
            className: "mb-0 text-center"
        }, text("".concat(product, "3D"))), /*#__PURE__*/ React.createElement("p", {
            className: "mb-0 text-center"
        }, text('clickForMoreInfo')))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row align-items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames("product-icon-container", _define_property({}, activeClass, !!activeClass))
    }, /*#__PURE__*/ React.createElement(IconWrapper, {
        icon: product,
        isActive: activeClass
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-info w-50 ml-2 d-flex flex-column"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 font-12 text-truncate"
    }, text("".concat(product))), /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 font-12 font-weight-normal text-truncate"
    }, getProductSubtitle())), /*#__PURE__*/ React.createElement("div", {
        className: "text-right product-info w-50 font-12 font-weight-normal"
    }, price)))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(BootstrapButton, {
        className: "row-action icon-button",
        variant: "light",
        onClick: handleDelete
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "trash"
    })))))), isProductModalOpened && /*#__PURE__*/ React.createElement(ProductModal, {
        ref: cardRef
    })));
};
Product.propTypes = {
    product: PropTypes.string,
    data: PropTypes.array.isRequired,
    charges: PropTypes.object.isRequired,
    isReadOnly: PropTypes.bool
};
export default Product;
